// 「全部主題」出題：各主題平均分配，主題內優先還沒答對過的題目
type Q = { ref?: { s: string; t: string; id: string } };

const shuffle = <T,>(a: T[], rnd: () => number) => {
  const b = [...a];
  for (let i = b.length - 1; i > 0; i--) { const j = Math.floor(rnd() * (i + 1)); [b[i], b[j]] = [b[j], b[i]]; }
  return b;
};

// items：所有候選題；topicOrder：主題順序（決定輪流順序與「全部」時的排列）
// mastered(q)：是否已答對過；count：題數（Infinity 表示全部）
export function pickBalanced<T extends Q>(
  items: T[], topicOrder: string[], count: number, mastered: (q: T) => boolean, rnd: () => number = Math.random,
): T[] {
  const byTopic = new Map<string, T[]>();
  for (const q of items) {
    const t = q.ref?.t ?? '';
    if (!byTopic.has(t)) byTopic.set(t, []);
    byTopic.get(t)!.push(q);
  }
  const order = [...topicOrder.filter(t => byTopic.has(t)), ...Array.from(byTopic.keys()).filter(t => !topicOrder.includes(t))];
  // 全部：依主題順序、主題內維持原順序
  if (!isFinite(count) || count >= items.length) return order.flatMap(t => byTopic.get(t)!);

  // 每個主題的佇列：未答對（隨機）在前，已答對（隨機）在後
  const queues = order.map(t => {
    const list = byTopic.get(t)!;
    return [...shuffle(list.filter(q => !mastered(q)), rnd), ...shuffle(list.filter(q => mastered(q)), rnd)];
  });
  // 輪流從各主題取一題（主題順序也打散，避免題數不整除時總是前面的主題多一題）
  const idx = shuffle(queues.map((_, i) => i), rnd);
  const picked: T[] = [];
  while (picked.length < count) {
    let took = false;
    for (const i of idx) {
      if (picked.length >= count) break;
      const q = queues[i].shift();
      if (q) { picked.push(q); took = true; }
    }
    if (!took) break;
  }
  return shuffle(picked, rnd);
}
